module.exports = __webpack_public_path__ + "static/sub-title.8f9dcd43.png";